import { graphql, useStaticQuery } from "gatsby"

const query = graphql`
  query SikhTemples {
		allSikhTemplesCsv(sort: {order: ASC, fields: english_name_I}) {
			edges {
				node {
					chinese_name_I
					chinese_name_II
					english_name_I
					english_name_II
					id
					latitude
					longitude
					established_year
					full_address
					telephone_number
          date_sketch_created
				}
			}
		}
	}
`

const useSikhTemplesData = () => {
  let {
    allSikhTemplesCsv: { edges }
  } = useStaticQuery(query)

  let data = edges.map(x => x.node)

  return data
}

export default useSikhTemplesData
